import {Order} from '../../types';

import {deliveryDateTypes} from '../../static_data/deliveryDateTypes';

export function isDayDelivery(order: Order): boolean {
    if (order.deliveryDateType === deliveryDateTypes.DAY.key) {
        return true;
    }
    return false;
}